<template>
  <div class="inner-box">
    <el-form :model="form" :rules="rules" ref="configInfoForm" size="mini">
      <el-row>
        <el-col :span="12">
          <el-form-item label="상위분류명">
            <el-input type="text" v-model="form.parentNm" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="분류명" prop="configNm">
            <el-input type="text" v-model="form.configNm"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="KEY" prop="configKey">
            <el-input type="text" v-model="form.configKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="VALUE">
            <el-input type="text" v-model="form.configValue"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="비고">
            <el-input 
              type="textarea" 
              :autosize="{ minRows: 4, maxRows: 6}"
              placeholder="비고를 작성하세요."
              v-model="form.description"></el-input>
            <el-input type="hidden" v-model="form.configId"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ConfigInfo",
  props: ['configDetail', 'parentNm'],
  data() {
    return {
      form: {
        parentNm: "",
        configKey: "",
        configNm: "",
        configId: "",
        description: "",
        configValue: "",

        // parentId: "",
        // TopKey: "",
        // configIdx: "",
      },
      rules: {
/*        configNm: [
          { required: true, message: '분류명을 입력하세요.', trigger: 'blur' },
          { min: 3, max: 10, message: '최소 3글자 최대 10글자 입력', trigger: 'blur' }
        ],
        configKey: [
          { required: true, message: '키를 입력하세요.', trigger: 'blur' },
          { min: 1, message: '최소 1글자', trigger: 'blur' }
        ],*/
      }
    }
  },
  methods: {
    setconfigInfo() {
      this.form = this.configDetail;
      this.form.parentNm = this.parentNm;
      // Object.assign(this.form, this.configDetail, this.parentNm);
    },
  },
  watch: {
    configDetail() {
      this.setconfigInfo();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: -20px;
  }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
</style>